export default {
  global: {
    color: '#333',
    backgroundColor: 'white',
    green: '#5ebe77',
    greenBorder: '#46b463',
    blue: '#3bc0c3',
    blueBorder: '#219c9f',
    tealBg: '#3bc0c3',
    buttonText: 'white',
  },

  header: {
    color: '#333',
    backgroundColor: 'rgba(255,255,255,0.95)',
  },

  getStartedNow: {
    text: 'white',
    backgroundColor: '#124a53',
  },

  howKidsImprove: {
    text: 'white',
    backgroundColor: '#0e91a1',
  },

  stressFree: {
    text: '#333',
    backgroundColor: 'white',
  },

  research: {
    text: 'white',
    backgroundColor: '#86d2dd',
  },

  collaborate: {
    text: '#333',
    backgroundColor: 'white',
  },

  potential: {
    text: 'white',
    backgroundColor: '#86d2dd',
  },

  footer: {
    text: 'rgb(174, 174, 174)',
    backgroundColor: '#f6f7f8',
  },

  tos: {
    text: '#333',
    backgroundColor: 'white',
  },

  privacy: {
    text: '#333',
    backgroundColor: 'white',
  },

  about: {
    text: '#333',
    backgroundColor: 'white',
    description: {
      backdrop: 'rgba(13, 50, 56, 0.98)',
      text: 'white',
      backgroundColor: '#124a53',
    },
  },

  contact: {
    text: '#333',
    backgroundColor: 'white',
    header: {
      text: 'white',
      backgroundColor: '#86d2dd',
    },
  },

  getStarted: {
    text: 'white',
    backgroundColor: '#86d2dd',
    sideContent: {
      text: 'white',
      backgroundColor: '#86d2dd',
    },
  },

  ourResearch: {
    text: '#333',
    backgroundColor: 'white',
  },
};
